<template>
  <section class="testimonials-section">
    <div class="container">
      <h2 class="section-title">Patient Testimonials</h2>
      <div class="testimonials-grid">
        <div v-for="(testimonial, index) in testimonials" :key="index" class="testimonial-card">
          <div class="testimonial-content">
            <i class="fas fa-quote-left"></i>
            <p>{{ testimonial.content }}</p>
            <div class="testimonial-author">
              <strong>{{ testimonial.author }}</strong>
              <span>{{ testimonial.date }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TestimonialsSection',
  data() {
    return {
      testimonials: [
        {
          content: "Dr. Mayo Lee provided exceptional care during my treatment. His expertise and attention to detail made all the difference.",
          author: "John D.",
          date: "June 2023"
        },
        {
          content: "I'm extremely satisfied with the results of my procedure. Dr. Lee's professionalism and care were outstanding.",
          author: "Sarah M.",
          date: "July 2023"
        },
        // Add more testimonials as needed
      ]
    }
  }
}
</script>

<style scoped>
.testimonials-section {
  padding: 60px 0;
  background-color: #f8f9fa;
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  padding: 20px;
}

.testimonial-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  padding: 25px;
  transition: transform 0.3s ease;
}

.testimonial-card:hover {
  transform: translateY(-5px);
}

.testimonial-content {
  position: relative;
}

.fa-quote-left {
  color: #007bff;
  font-size: 24px;
  margin-bottom: 15px;
}

.testimonial-author {
  margin-top: 15px;
  text-align: right;
}

.testimonial-author strong {
  display: block;
  color: #333;
}

.testimonial-author span {
  color: #666;
  font-size: 0.9em;
}
</style>
